import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Utils/Button';
import { analytics } from '../Core/AnalyticsManager';
import VersionTracker from '../../utils/VersionTracker';

export const changelogData = {
  "1.0.0": {
    title: "Welcome to Tilefolk.io v1.0!",
    date: "December 2025",
    changes: [
      "Initial release of Tilefolk.io - The #1 Carcassonne online alternative",
    ]
  },
  "1.1.0": {
    title: "Welcome to Tilefolk.io v1.1!",
    date: "January 2026",
    changes: [
      "Bots can now place farmers - so watch out!",
      "Enabled the Farmers ON/OFF room setup button - but who doesn't like farmers?!",
    ]
  }
  // Future versions added here
};

class ChangelogModal extends React.Component
{
  constructor( props )
  {
    super( props );
    this.handleClose = this.handleClose.bind( this );
  }

  componentDidUpdate( prevProps )
  {
    // Only track when the modal actually becomes visible
    if( !prevProps.show && this.props.show )
    {
      analytics.track( 'changelog_viewed', {
        version: this.props.version
      } );

      VersionTracker.markVersionAsSeen();
    }
  }

  handleClose()
  {
    analytics.track( 'changelog_closed', {
      version: this.props.version
    } );
    this.props.onClose();
  }

  render()
  {
    const { version, show } = this.props;
    const changelog = changelogData[ version ];

    if( !changelog )
    {
      return null;
    }

    return (
      <Modal
        show={ show }
        onHide={ this.handleClose }
        centered
        className="modal-popup changelog-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal-popup-title">
            { changelog.title }
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="changelog-modal-content">
            <div className="changelog-version-info">
              <span className="changelog-version">Version { version }</span>
              <span className="changelog-date">{ changelog.date }</span>
            </div>

            <div className="changelog-changes">
              <h4>What's New:</h4>
              <ul className="changelog-list">
                { changelog.changes.map( ( change, index ) => (
                  <li key={ index } className="changelog-item">
                    { change }
                  </li>
                ) ) }
              </ul>
            </div>

            <div className="changelog-footer-text">
              Thank you for playing Tilefolk.io! We hope you enjoy the game.
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            onClick={ this.handleClose }
            style={ {
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              minWidth: '100px'
            } }
          >
            Got it!
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ChangelogModal;
